import { DELIVERY_OPTIONS_TYPES } from './Components/PaymentAndDelivery';
import { PURCHASE_STEPS_KEYS } from './Containers';
import { Devices, Purchase, DeviceFullSpecs } from './Screens';

export { Devices, Purchase, DeviceFullSpecs, PURCHASE_STEPS_KEYS, DELIVERY_OPTIONS_TYPES };
export default Devices;
